var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { filter, uniq } from 'lodash';
import { classNames } from '../../utils/cn';
import { Tab } from '../elements/tab';
import { HorizontalScroll } from '../elements/horizontal-scroll';
import { formatDateString } from '../../utils/format-date-string';
import { useMonthNamesShort } from '../../hooks/use-month-names-short';
import { useEntity } from '../../hooks/use-entity';
var cls = classNames('event-session-tabs');
export var EventSessionTabsDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var TabsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    width: 100%;\n    margin-top: ", ";\n  "])), theme.UNIT(2)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(4))
});
var TabStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: block;\n    white-space: nowrap;\n    flex-wrap: nowrap;\n    font-weight: 500;\n    zindex: 10;\n    font-size: ", ";\n    padding: ", " ", ";\n    text-transform: capitalize;\n\n    ", "\n\n    ", "\n\n    span {\n      text-transform: uppercase;\n      font-weight: 300;\n      margin-left: ", ";\n    }\n\n    &:last-child {\n      border-right: none;\n      padding-right: ", ";\n    }\n  "], ["\n    display: block;\n    white-space: nowrap;\n    flex-wrap: nowrap;\n    font-weight: 500;\n    zindex: 10;\n    font-size: ", ";\n    padding: ", " ", ";\n    text-transform: capitalize;\n\n    ", "\n\n    ", "\n\n    span {\n      text-transform: uppercase;\n      font-weight: 300;\n      margin-left: ", ";\n    }\n\n    &:last-child {\n      border-right: none;\n      padding-right: ", ";\n    }\n  "])), theme.FONT_SIZE(14), theme.UNIT(3), theme.UNIT(4), function (_a) {
    var totalCount = _a.totalCount,
        activeColor = _a.activeColor;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      flex-basis: calc(", "% - 1px);\n    "], ["\n      flex-basis: calc(", "% - 1px);\n    "])), 1 / totalCount * 100);
  }, function (_a) {
    var activeColor = _a.activeColor,
        isActive = _a.isActive;
    return isActive && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), activeColor);
  }, theme.UNIT(2), theme.UNIT(6)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", ";\n    font-size: ", ";\n  "], ["\n    padding: ", ";\n    font-size: ", ";\n  "])), theme.UNIT(4), theme.FONT_SIZE(18)),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(20))
});
var TabScrollStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FadeStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TabScroll: styled(HorizontalScroll)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TabScrollStyles),
  Tabs: styled.div.attrs(cls.attr('tabs'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Fade: styled.span.attrs(cls.attr('fade'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles),
  Tab: styled(Tab)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TabStyles)
};
export var EventSessionTabs = function EventSessionTabs(props) {
  var className = props.className,
      children = props.children,
      activeDay = props.activeDay,
      activeColor = props.activeColor,
      onDateChange = props.onDateChange,
      tabProps = __rest(props, ["className", "children", "activeDay", "activeColor", "onDateChange"]);

  var entity = useEntity(props.entity);
  var sessions = filter(entity.sessions || [], function (session) {
    return !!session.startDate;
  });
  var days = uniq(sessions.map(function (session) {
    return formatDateString(session.startDate, 'YYYY-MM-DD');
  }));
  var monthNamesShort = useMonthNamesShort();

  var onClick = function onClick(day) {
    return function () {
      if (onDateChange) {
        onDateChange(day);
      }
    };
  };

  if (days.length <= 1) {
    return null;
  }

  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.TabScroll, null, React.createElement(My.Tabs, null, days.map(function (day) {
    return React.createElement(My.Tab, __assign({}, tabProps, {
      key: day,
      activeColor: activeColor,
      onClick: onClick(day),
      totalCount: days.length || 1,
      isActive: day === activeDay
    }), formatDateString(day, 'D MMM YYYY', 'YYYY-MM-DD', {
      monthNamesShort: monthNamesShort
    }), React.createElement("span", null, formatDateString(day, '(ddd)', 'YYYY-MM-DD', {
      monthNamesShort: monthNamesShort
    })));
  }))), React.createElement(My.Fade, null));
};
EventSessionTabs.defaultProps = EventSessionTabsDefaultProps;
EventSessionTabs.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;